const showPOPUP = (event) => {
	// External dependencies
	const jquery = window.jQuery;
	const popupRoot = jquery("#coca-popup");

	// Detect the target and container for popup.
	const target = jquery(event.target);
	const containerClassList = target.parent().attr("class").trim();
	const wrapperClassList = target.parent().parent().attr("class").trim();
	const containerClass = containerClassList.split(/\s+/)[0];
	const wrapperClass = wrapperClassList.split(/\s+/)[0];

	if (!!containerClass && !!wrapperClass) {
		const hidePopup = (clickEvent, areaTarget) => {
			const cocaPopupRoot = jquery("#coca-popup");
			const popupContainer = cocaPopupRoot.find(".popup-container");

			if (areaTarget === "button") {
				cocaPopupRoot.removeClass("view");
				cocaPopupRoot.addClass("hide");
				popupContainer.html("");
			}

			if (
				areaTarget === "any" &&
				!clickEvent.target.closest(`.${containerClass}`) &&
				!clickEvent.target.closest(".popup-close")
			) {
				cocaPopupRoot.removeClass("view");
				cocaPopupRoot.addClass("hide");
				popupContainer.html("");
			}
		};

		// verify the landing element is existed or not.
		if (!popupRoot.length) {
			jquery("body").append(
				// eslint-disable-next-line max-len
				'<div id="coca-popup" class="view"><div class="popup-wrapper"><div class="popup-close">╳</div><div class="popup-container"></div></div></div>',
			);

			const close = jquery("#coca-popup .popup-close");
			const popupContainer = jquery("#coca-popup .popup-container");
			close.on("click", (xEvent) => hidePopup(xEvent, "button"));
			popupContainer.on("click", (anyEvent) => hidePopup(anyEvent, "any"));
		}

		// Detect the container for popup.
		const container = jquery("#coca-popup div.popup-container");

		// Determine the source root.
		const sourceContent = target.parent().parent().parent().parent();

		// Set html data for popup container.
		const clonedHtml = sourceContent.clone(true); // Deep clone

		// Collect html data from popup container.
		const widget = clonedHtml.find(`.${wrapperClass}`).parent().parent();

		// *** IMPORTANT CLEANUP ON CLONED CONTENT BEFORE APPENDING ***
		// 1. Unwrap the inner container IF it was wrapped by the plugin
		widget.find(`.${containerClass}`).unwrap(); // This removes the coca-image-compare-wrapper if present

		// 2. Remove all plugin-generated internal elements from the cloned container
		//    We need to do this on `clonedHtml` before it's put into the `popupContainer`
		const clonedCompareContainer = clonedHtml.find(`.${containerClass}`);
		clonedCompareContainer.removeClass("initialized"); // Remove 'initialized' class
		clonedCompareContainer.removeClass("popup-loaded"); // Also remove 'popup-loaded' for a fresh start

		// Remove the elements that the plugin *adds* internally
		clonedCompareContainer.find(".coca-image-compare-overlay").remove();
		clonedCompareContainer.find(".coca-image-compare-handle").remove();
		clonedCompareContainer.find(".coca-image-compare-handle-wrapper").remove(); // Remove the wrapper too
		clonedCompareContainer.find(".coca-image-compare-overlay-image").remove();
		clonedCompareContainer.find(".video-control-area").remove(); // If videos are part of this
		clonedCompareContainer.find(".coca-bais-badge").remove(); // Remove badge — re-init will re-inject it

		// Also remove classes that the plugin adds to the images/videos
		clonedCompareContainer
			.find("img, iframe, video")
			.removeClass("coca-image-compare-before coca-image-compare-after");

		// Now, put the cleaned cloned HTML into the popup container
		container.html(clonedHtml.prop("outerHTML")); // Or clonedHtml.html() if you only want inner HTML

		// Ensure the main container within the popup is now the correct element to work with
		const popupCompareRoot = container.find(`.${containerClass}`);

		// Active the popup for view.
		if (popupRoot.hasClass("hide")) {
			popupRoot.removeClass("hide");
			popupRoot.removeClass("loaded");
			popupRoot.addClass("view");
		}

		if (jquery("#coca-popup.view").length) {
			window.setTimeout(() => {
				const popup = jquery("#coca-popup.view");
				popup.addClass("loaded");

				if (popupCompareRoot.length) {
					// Use popupCompareRoot here
					popupCompareRoot.attr("data-id", popupCompareRoot.attr("id"));
					const pluginSettings = popupCompareRoot.data("settings");
					const settingsData =
						typeof pluginSettings === "string" ? JSON.parse(pluginSettings) : pluginSettings;

					// Update class-list for elementor.
					["wp-post", "wp-page"].forEach((position) => {
						if (jquery(`div[data-elementor-type="${position}"] #${popupCompareRoot.attr("id")}`).length) {
							container.addClass(jquery(`div[data-elementor-type="${position}"]`).attr("class"));
						}
					});

					if (containerClass === "coca-bais-container") {
						// Re-initialize the plugin on the cleaned clone
						popupCompareRoot.coca_imageCompare(settingsData);
						popupCompareRoot.addClass("popup-loaded"); // Add this class back after re-init
					}

					if (containerClass === "coca-bais-triple-container") {
						popupCompareRoot.coca_tripleImageCompare(settingsData);
						popupCompareRoot.addClass("popup-loaded");
					}
				}
			}, 600);

			window.setTimeout(() => {
				const popup = jquery("#coca-popup.view");
				popup.find(`.${containerClass}`).removeClass("hide");
				popup.removeClass("view").addClass("loaded").find(".coca-bais-image");
			}, 700);

			setTimeout(() => {
				jquery("#coca-popup").find(".coca-bais-image").addClass("coca-bais-image-add-height");
			}, 1000);
		}
	}
};

// fire copy
window.jQuery(".coca-bais-triple-container .popup-button, .coca-bais-container .popup-button").on("click", showPOPUP);
